import { useCompanyLabels } from '../../context/CompanyContext';
import React from 'react';

/** Store values remain IDs; labels come from the parent catalog. */
export default function StoreSelect({ storeList = [], value, onChange, ...props }) {
  const { label } = useCompanyLabels();
  return (
    <select {...props} className="review-control" value={value ?? ''} onChange={(event) => onChange(event.target.value)}>
      <option value="">{label('Select Store')}</option>
      {storeList.map((store) => (
        <option key={store.id} value={store.id}>{store.name ?? store.label ?? String(store.id)}</option>
      ))}
    </select>
  );
}
